import React, { useState, useEffect, useMemo } from 'react'
import { useWeb3React } from '@web3-react/core'
import { useCustodainContract } from './useContract'
import { providers } from 'ethers'
import { useDispatch } from 'react-redux'
import {
    setStateKey,
  } from '../redux/slices/affiliateSlice'
  import { displayCurrency, displayCurrencyForInput } from '../utils/helpers'

export const useStake = () => {


    const dispatch = useDispatch()
    const contract = useCustodainContract()

    const checkStaking = async (account:any) => {
        const response = await contract.isStaking(account)
        dispatch(setStateKey({ key: 'isStaking', value: response }))
        if(response == false){
          dispatch(setStateKey({ key: 'isApprovedToken', value: 'none' }))
        }
        return response
    }
    const setIsApproveToken = async () => {
      dispatch(setStateKey({ key: 'isApprovedToken', value: 'none' }))
    }

    const getStakeBlance = async (account:any) => {
        const balance = await contract.balanceOf(account)
        dispatch(setStateKey({ key: 'balanceOfStaking', value: displayCurrencyForInput(balance)}))
      }



return {
    checkStaking,
    getStakeBlance,
    setIsApproveToken,
}

} // end  hook

